import Reveal from "@/components/Reveal";
import { testimonials } from "@/data/siteData";

export default function TestimonialsSection() {
  return (
    <section className="testimonials-section" id="testimonials" data-testid="testimonials-section">
      <div className="section-shell">
        <Reveal className="testimonials-intro" delay={70}>
          <div className="eyebrow"><span className="eyebrow__dot" /> 04 / Client words</div>
          <h2>Trusted quietly.<br /><em>Praised openly.</em></h2>
          <p>The standard is easiest to see through the eyes of the people who live with it.</p>
        </Reveal>
        <div className="testimonials-grid">
          {testimonials.map((item, index) => (
            <Reveal as="figure" className="testimonial-card" delay={130 + index * 110} key={item.id} data-testid={`testimonial-card-${index + 1}`}>
              <span className="testimonial-card__mark" aria-hidden="true">“</span>
              <blockquote data-testid={`testimonial-quote-${index + 1}`}>{item.quote}</blockquote>
              <figcaption>
                <strong data-testid={`testimonial-name-${index + 1}`}>{item.name}</strong>
                <span data-testid={`testimonial-title-${index + 1}`}>{item.title}</span>
              </figcaption>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
